module.exports = __webpack_public_path__ + "static/media/iforwilliams.8658e15e.png";